import React from 'react'
import { useSelector } from 'react-redux'

import SmsOverLimit from './SmsOverLimit'
import SmsSettingsAlert from './SmsSettingsAlert'
import PremiumMember from './PremiumMember'
import PremiumCTA from './PremiumCTA'
import PremiumDelinquent from './PremiumDelinquent'
import SurveyWhoCard from './Survey/Who/Card'

const PremiumAsk = () => {
  const possibleSession = useSelector(store => store.session.isAuthenticated)
  const userFetching = useSelector(store => store.user.fetching)
  const fetched = useSelector(store => store.user.fetched)
  const user = useSelector(store => store.user.userV2)
  const premium = useSelector(store => store.user.premium)

  // Loading user
  if (userFetching) {
    return null
  }

  // No user but marked premium - availabilityMatch
  if (!fetched && premium) {
    return <PremiumMember />
  }

  // Logged out user, not premium on availabilityMatch
  if (!possibleSession) {
    return <PremiumCTA />
  }

  if (!fetched || !premium) {
    return <PremiumCTA />
  }

  if (!user.smsUnderLimit) {
    return <SmsOverLimit />
  }

  if (user.delinquent) {
    return <PremiumDelinquent />
  }

  if (user.featureSurveyWho && !user.surveyWhoComplete) {
    return <SurveyWhoCard />
  }

  return (
    <>
      <PremiumMember />
    </>
  )
}

export default PremiumAsk

// const connected = connect(store => {
//   return {
//     premium: store.user.premium,
//     premiumAmount: store.user.premiumAmount,
//     smsUnderLimit: store.user.user.sms_under_limit,
//     isAuthenticated: store.session.isAuthenticated
//   }
// })
// export class PremiumAsk extends Component {
//   premiumAmountChange = (e, { value }) => this.props.dispatch({ type: 'SET_PREMIUM_AMOUNT', payload: value })

//   render() {
//     const { premium, smsUnderLimit, isAuthenticated } = this.props

//     if (isAuthenticated && premium && !smsUnderLimit) {
//       return <SmsOverLimit />
//     }

//     return (
//       <>
//         {isAuthenticated && premium && smsUnderLimit && <SmsSettingsAlert />}
//         {premium && <PremiumMember />}
//         {!premium && <PremiumCTA />}
//       </>
//     )
//   }
// }
// export default connected(PremiumAsk)
